module.exports = __webpack_public_path__ + "img/oci_owner.b803b65f.svg";